import React from 'react';
import HiddenInput from 'shared/components/HiddenInput';

const RowSelected = (props) => {
  const { parameters } = props;
  const name = 'row_selected';
  let value = parameters[name];

  if (value !== undefined && typeof value === 'number') {
    value = value.toString();
  }
  return (
    <HiddenInput name={name} value={value === undefined ? '' : value} />
  );
};

export default RowSelected;
